"use client";
import type { Prisma } from "@-/prisma";
import { createContext } from "react";
import type { programInclude } from "./include";

export type ProgramLayoutContext = {
  program: Prisma.ProgramGetPayload<{
    include: typeof programInclude;
  }>;
};

const LayoutContext = createContext<ProgramLayoutContext>(null!);

export default LayoutContext;
